// extracted by mini-css-extract-plugin
export default {"scholarships":"styles_scholarships__l4KbW","keyDetailsDesc":"styles_keyDetailsDesc__qnxS2","featuresDesc":"styles_featuresDesc__jzpkj","icon":"styles_icon__AhPEI"};